import Auth from "../../auth/Auth";
import EmailModal from "./EmailModal";
import AppConfig from "AppConfig";
import Helper from "../../legacy/helper";

class Login {
    /**
     *
     * @param ssoLoginUri : Function that should return a SSO login URI
     * (socialId) => {}
     * @param ssoLoginDataFeed : Function that should return data to pass to SSO login API
     * (userId, accessToken) => {}
     */
    constructor(ssoLoginUri, ssoLoginDataFeed) {
        this.ssoLoginUri = ssoLoginUri;
        this.ssoLoginDataFeed = ssoLoginDataFeed;
        this.emailModal = undefined;
    }

    /**
     * Will be called when user successfully logged in with Google.
     * It will call SSO with some information taken from Google
     * @param googleUser : GoogleUser (see https://developers.google.com/identity/sign-in/web/reference#googleusergetid)
     */
    onGoogleSignIn = (googleUser) => {
        let accessToken = googleUser.getAuthResponse().id_token,
            userId = googleUser.getBasicProfile().getId();

        this.ssoLogin("google", userId, accessToken);
    }

    /**
     * Will be called when user successfully logged in with Facebook.
     * It will call SSO with some information taken from Facebook
     * @param loginResponse : Facebook Login response (see https://developers.facebook.com/docs/reference/javascript/FB.getLoginStatus/)
     */
    onFacebookSignIn = (loginResponse) => {
        if (loginResponse.status === 'connected' &&
            loginResponse.authResponse && loginResponse.authResponse.accessToken &&
            loginResponse.authResponse.userID) {
            this.ssoLogin("facebook", loginResponse.authResponse.userID, loginResponse.authResponse.accessToken);
        }
    }

    /**
     * Will be called when user click on Google login button.
     */
    googleLogin = () => {
        window.gapi.auth2.getAuthInstance().signIn().then(this.onGoogleSignIn);
    };

    /**
     * Will be called when user click on Facebook login button.
     */
    facebookLogin = () => {
        window.FB.login(this.onFacebookSignIn, { scope : AppConfig.facebookPermissions });
    };

    /**
     * Will call SSO with minimal information coming from Google/Facebook
     * @param socialId
     * @param userId
     * @param accessToken
     * @param email (optional) : coming from Email modal
     * @param lastname (optional) : coming from Email modal
     */
    ssoLogin = (socialId, userId, accessToken, email, lastName) => {
        $.ajax({
            type: 'POST',
            url: this.ssoLoginUri(socialId),
            // Always include an `X-Requested-With` header in every AJAX request,
            // to protect against CSRF attacks.
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(this.ssoLoginDataFeed(userId, accessToken, email, lastName))
        })
        .done(Login.redirectAfterLogin)
        .fail((response) => {
            let isEmailMissing = response && response.responseJSON && response.responseJSON.isEmailMissing;
            let isLastNameMissing = response && response.responseJSON && response.responseJSON.isLastNameMissing;
            if(isEmailMissing || isLastNameMissing) {
                // Special case : user successfully logged in, but social network is not giving back user email
                // Display a modal to ask user's email
                if(!this.emailModal) {
                    this.emailModal = new EmailModal(socialId, userId, accessToken, this.ssoLogin, isEmailMissing, isLastNameMissing);
                }
                this.emailModal.show();
            } else {
                Login.showErrorMessage(response);
            }
        });
    };

    static redirectAfterLogin(response) {
        if(response && response.redirectUri) {
            window.location.replace(response.redirectUri)
        }
    }

    static showErrorMessage(response) {
        if(response && response.responseJSON && response.responseJSON.error) {
            if (response.responseJSON.code === 190) {
                $(".login-page-error__text").text(response.responseJSON.error);
                setTimeout(function () {
                    window.location.reload();
                }, 1500);
            } else (response && response.responseJSON && response.responseJSON.error)
            {
                $(".login-page-error__text").text(response.responseJSON.error);
            }
        } else {
            let defaultErrorMessage = "Sorry, das hätte nicht passieren dürfen. Bitte versuchen Sie es nochmal.";
            if(Helper.getLang() === "en") defaultErrorMessage = "We're sorry, that shouldn't have happened. Please try again later.";

            $(".login-page-error__text").text(defaultErrorMessage); // TODO RCH : create translation files for frontend
        }
        $(".login-page-error").addClass("login-page-error--visible");
    }

    initFacebookLoginButton = () => $(".facebook-btn").click(this.facebookLogin);
    initGoogleLoginButton = () => $(".google-btn").click(this.googleLogin);

    init = () => {
        // Load social APIs and initialize social buttons
        Auth.loadGoogleAuthApi(this.initGoogleLoginButton);
        Auth.loadFacebookAuthApi(this.initFacebookLoginButton);
    }
}

export default Login;



// WEBPACK FOOTER //
// ./js/page/login/Login.js